import { useEffect, useRef } from 'react';

/**
 * Camadas que fecham no Esc (imagem ampliada, janelas, menus): o Esc fecha só a de cima (a última
 * aberta) e não chega a quem está embaixo, como a conversa (`EscToClose`). Um único ouvinte na fase
 * de captura roda antes dos outros ouvintes da janela e dos handlers do React.
 */
const stack: Array<{ close: () => void }> = [];

function onKey(e: KeyboardEvent) {
  if (e.key !== 'Escape' || stack.length === 0) return;
  e.stopImmediatePropagation();
  e.preventDefault();
  stack[stack.length - 1].close();
}

export function pushEscapeLayer(close: () => void): () => void {
  const layer = { close };
  if (stack.length === 0) window.addEventListener('keydown', onKey, true);
  stack.push(layer);
  return () => {
    const i = stack.indexOf(layer);
    if (i >= 0) stack.splice(i, 1);
    if (stack.length === 0) window.removeEventListener('keydown', onKey, true);
  };
}

/** Registra a camada enquanto `enabled`; `onClose` pode mudar a cada render sem trocar a posição na pilha. */
export function useEscapeLayer(enabled: boolean, onClose: () => void) {
  const ref = useRef(onClose);
  ref.current = onClose;
  useEffect(() => {
    if (!enabled) return;
    return pushEscapeLayer(() => ref.current());
  }, [enabled]);
}
